module.exports = __webpack_public_path__ + "img/i_bee-times.06b722d3.svg";